import React from 'react';
import { createPortal } from 'react-dom';

/**
 * CustomViewContextMenu - Right-click context menu for views
 * Uses a portal to render at document body level to avoid transform issues
 * 
 * Note: The last view cannot be deleted (at least one must remain)
 */
const CustomViewContextMenu = ({
  contextMenu,
  contextMenuRef,
  onRename,
  onDuplicate,
  onDelete,
  onClose,
  totalViews = 1,
}) => {
  if (!contextMenu) return null;

  const canDelete = totalViews > 1;

  return createPortal(
    <div
      ref={contextMenuRef}
      className="view-bar__context-menu"
      style={{ left: contextMenu.x, top: contextMenu.y }}
    >
      <button
        className="view-bar__context-menu-item"
        onClick={() => onRename(contextMenu.view)}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
        Rename
      </button>
      <button
        className="view-bar__context-menu-item"
        onClick={() => {
          onDuplicate(contextMenu.view.id);
          onClose();
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
        </svg>
        Duplicate
      </button>
      {canDelete && (
        <>
          <div className="view-bar__context-menu-divider" />
          <button
            className="view-bar__context-menu-item view-bar__context-menu-item--danger"
            onClick={() => {
              onDelete(contextMenu.view.id);
              onClose();
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
            </svg>
            Delete
          </button>
        </>
      )}
    </div>,
    document.body
  );
};

export default CustomViewContextMenu;
